import { Action } from '@ngrx/store';
import { ConcreteProposalOP, SlotsResponseOP } from '@cemex-core/cmx-api';
import { OrderStatusModify } from '../../models/order-status-modify-snapshot.model';
import { RecipeFormValues } from '@ordersnproducts/modules/order-builder/modules/retail-specification/models/form-values';

export enum ActionTypes {
  SET_REQUEST_DATETIME = '[MOO DCO] Set Request Datetime',

  FETCH_SLOTS = '[MOO DCO] Fetch Slots',
  FETCH_SLOTS_SUCCESS = '[MOO DCO] Fetch Slots Success',
  FETCH_SLOTS_ERROR = '[MOO DCO] Fetch Slots Error',
  MARK_SLOT_AVAILABLE = '[MOO DCO] Slot Available',
  SAVE_FORM_SNAPSHOT = '[MOO DCO] Save Form Snapshot',

  CHECK_WAITING_LIST = '[MOO DCO] Check Waiting List',
  SELECT_DATETIME_SLOT = '[MOO DCO] Select Datetime Slot',
  SET_SELECTED_SLOT = '[MOO DCO] Set selected slot',
  RESET_SELECTED_SLOT = '[MOO DCO] Reset selected slot',

  ENABLE_FULL_VISIBILITY = '[MOO DCO] Enable Full Visibility',
  TRIGGER_RESET_WARNING = '[MOO DCO] Trigger Reset Warning',
  SET_FORM_READY = '[MOO DCO] Set Form Ready',
  SET_CUTOFF_DATE = '[MOO DCO] Set Cutoff Date',
  SET_OFFER_DAYS = '[MOO DCO] Set Offer Days',
  SET_SPECIAL_SCENARIOS = '[MOO DCO] Set Special Scenarios',
  RESET_SLOT = '[MOO DCO] Reset Slot',
  RESET_STATE = '[MOO DCO] Reset DCO State ',
  RESET_DCO_SLOTS = '[MOO DCO] Reset DCO Slots',

  DELETE_DATA = '[MOO DCO] Delete Data',
  //   REMOVE_ITEM = '[MOO DCO] Remove item',
  //   REMOVE_ITEM_SUCCESS = '[MOO DCO] Remove item Success',
  DUMMY_FETCH_SLOTS_SUCCESS = '[MOO DCO] Dummy Fetch Slot Success',
  //   UNSHIFT_TIME_SLOTS = '[DCO] Unshift time slots',
  //   FORMAT_DATA_FOR_CALENDAR_VIEW_SUCCESS = '[DCO] Format data for calendar view success',
  DELETE_MODIFY_ORDER_STATUS = '[MOO DCO] DELETE ORDER MODIFY STATUS',
  SET_MODIFY_ORDER_STATUS = '[MOO DCO] SET ORIGINAL ORDER STATUS',
  ORDER_MODIFY_HAVE_CHANGES = '[MOO DCO] MODIFY order have changes',
  REMOVE_SPECIAL_SCENARIO = '[MOO DCO] Remove Special Scenario',
  ACCEPT_LIABILITY_CHECK = '[MOO DCO] Accept Liability Check',

  SAVE_SLOTS_OUT_OF_SERVICE = '[MOO DCO] Load Slots Out Of Service',
  SAVED_SLOTS_OUT_OF_SERVICE_CHECK = '[MOO DCO] Load Slots Out Of Service Check',
  SAVED_SLOTS_OUT_OF_SERVICE_RESET = '[MOO DCO] Load Slots Out Of Service Reset',
}

export class SetRequestDatetime implements Action {
  readonly type = ActionTypes.SET_REQUEST_DATETIME;
  //    isAvailable?: boolean
  constructor(public payload: { formID: number; moment: moment.Moment }) {}
}

export class CheckWaitingList implements Action {
  readonly type = ActionTypes.CHECK_WAITING_LIST;
  constructor(public payload: { formID: number; checked: boolean }) {}
}
export class SelectDatetimeSlot implements Action {
  readonly type = ActionTypes.SELECT_DATETIME_SLOT;
  constructor(public payload: { formID: number; moment: moment.Moment; isAvailable?: boolean }) {}
}

export class SetSelectedSlot implements Action {
  readonly type = ActionTypes.SET_SELECTED_SLOT;
  constructor(public payload: ConcreteProposalOP) {}
}

export class ResetSelectedSlot implements Action {
  readonly type = ActionTypes.RESET_SELECTED_SLOT;
  constructor() {}
}

export class FetchSlots implements Action {
  readonly type = ActionTypes.FETCH_SLOTS;
  constructor(public payload: { formID: number }) {}
}

export class FetchSlotsSuccess implements Action {
  readonly type = ActionTypes.FETCH_SLOTS_SUCCESS;
  constructor(public payload: { formID: number; response: SlotsResponseOP }) {}
}

export class FetchSlotsError implements Action {
  readonly type = ActionTypes.FETCH_SLOTS_ERROR;
  constructor(public payload: { formID: number; error: any; country?: string }) {}
}

export class EnableFullVisibility implements Action {
  readonly type = ActionTypes.ENABLE_FULL_VISIBILITY;
  constructor(public payload: { formID: number; enable: boolean }) {}
}

export class SetFormReady implements Action {
  readonly type = ActionTypes.SET_FORM_READY;
  constructor(public payload: { formId: number; formReady: boolean }) {}
}

export class SetCutOffDate implements Action {
  readonly type = ActionTypes.SET_CUTOFF_DATE;
  constructor(public payload: { date: moment.Moment }) {}
}

export class SetOfferDays implements Action {
  readonly type = ActionTypes.SET_OFFER_DAYS;
  constructor(public payload: { days: number }) {}
}

export class TriggerResetWarning implements Action {
  readonly type = ActionTypes.TRIGGER_RESET_WARNING;
  constructor(public payload: { formId: number; trigger: boolean }) {}
}

export class DeleteData implements Action {
  readonly type = ActionTypes.DELETE_DATA;
  constructor() {}
}

export class ResetComponentState implements Action {
  readonly type = ActionTypes.RESET_STATE;
  constructor() {}
}

// export class RemoveItem implements Action {
//   readonly type = ActionTypes.REMOVE_ITEM;
//   constructor(public payload: { formId: number; formIndex: number }) {}
// }
// export class RemoveItemSuccess implements Action {
//   readonly type = ActionTypes.REMOVE_ITEM_SUCCESS;
//   constructor() {}
// }

export class MarkSlotAvailable implements Action {
  readonly type = ActionTypes.MARK_SLOT_AVAILABLE;
  constructor(public payload: { formID: number; isAvailable: boolean }) {}
}

export class ResetSlots implements Action {
  readonly type = ActionTypes.RESET_SLOT;
  constructor(public payload: { formId: number }) {}
}

export class SaveFormSnapshot implements Action {
  readonly type = ActionTypes.SAVE_FORM_SNAPSHOT;
  constructor(public payload: { formId: number; formSnapshot: RecipeFormValues }) {}
}

export class DummyFetchSlotsSuccess implements Action {
  readonly type = ActionTypes.DUMMY_FETCH_SLOTS_SUCCESS;
  constructor(public payload: { formId: number; formSnapshot: RecipeFormValues }) {}
}

export class SetSpecialScenarios implements Action {
  readonly type = ActionTypes.SET_SPECIAL_SCENARIOS;
  constructor(public payload: { formId: string; scenarios: { [key: string]: boolean } }) {}
}

export class DeleteModifyOrderStatus implements Action {
  readonly type = ActionTypes.DELETE_MODIFY_ORDER_STATUS;
  constructor() {}
}
// VolumeAllocation

export class ModifyOrderHaveChanges implements Action {
  readonly type = ActionTypes.ORDER_MODIFY_HAVE_CHANGES;
  constructor(public payload: boolean) {}
}
export class SetOriginalOrderStatus implements Action {
  readonly type = ActionTypes.SET_MODIFY_ORDER_STATUS;
  constructor(public payload: OrderStatusModify) {}
}
export class RemoveSpecialScenario implements Action {
  readonly type = ActionTypes.REMOVE_SPECIAL_SCENARIO;
  constructor(public payload: { formId: string; scenario: string }) {}
}

/**
 * Action to update when the user accepts the liability check
 */
export class AcceptLiabilityCheck implements Action {
  readonly type = ActionTypes.ACCEPT_LIABILITY_CHECK;
  constructor(public payload: { formID: number; checked: boolean }) {}
}

export type Actions =
  | SetRequestDatetime
  | FetchSlots
  | FetchSlotsSuccess
  | FetchSlotsError
  | MarkSlotAvailable
  | ResetSlots
  | SaveFormSnapshot
  | CheckWaitingList
  | SelectDatetimeSlot
  | EnableFullVisibility
  | SetFormReady
  | SetCutOffDate
  | SetOfferDays
  | TriggerResetWarning
  | SetSpecialScenarios
  | SetSelectedSlot
  | DeleteData
  //   | ResetSlots
  //   | RemoveItem
  //   | RemoveItemSuccess
  //   | SaveFormSnapshot
  | DummyFetchSlotsSuccess
  //   | UnshiftTimeSlots
  | SetOriginalOrderStatus
  | DeleteModifyOrderStatus
  | ModifyOrderHaveChanges
  | ResetComponentState
  | RemoveSpecialScenario
  | AcceptLiabilityCheck
  | ResetSelectedSlot;
